module.exports = __webpack_public_path__ + "img/nav_5_disable.db676997.png";